<script lang="ts">
    export let task: TaskOilSpillRemoval | TaskTowing
</script>

<div class="col2">
    <span>Einsatz</span>
    <div>
        <img
            src="../../../assets/icons/solar_waterdrops-outline.svg"
            alt="icon"
        />
        <ul class="ulcontent">
            <li class="contentTextBold">{task.generalDetails.shortDescription}</li>
        </ul>
    </div>
</div>

<style lang="less">
    .col2 {
        display: flex;
        align-items: felx-end;
        flex-grow: 1;
        flex-direction: column;
        gap: 6px;
        span {
            font-family: Inter-Bold;
            font-size: 0.5rem;
            line-height: 0.5rem;
            font-weight: 700;
            text-transform: uppercase;
        }

        & > div {
            display: flex;
            gap: 0.6rem;
            .ulcontent {
                display: flex;
                align-items: center;
                li {
                    border-left: 1px solid var(--white-100);
                    padding: 0px 0.6rem;
                    height: fit-content;
                    font-size: 1.2rem;
                    font-weight: 400;
                    font-family: Inter-Regular;
                    line-height: 1.2rem;
                    color: var(--white-100);
                    &:first-child {
                        border-left: none;
                        padding-left: 0px;
                    }
                }
            }
        }
    }
</style>
